export default __webpack_public_path__ + "static/media/home-1.4222ac59.jpg";